import { render, staticRenderFns } from "./CreateDiscountDialog.vue?vue&type=template&id=0fb2413e"
import script from "./CreateDiscountDialog.vue?vue&type=script&lang=js"
export * from "./CreateDiscountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports